import React from "react";
import { Link } from "react-router";

function Header() {
  var today = new Date();
  var year = today.getFullYear();
  var month = ("0" + (today.getMonth() + 1)).slice(-2);
  var day = ("0" + today.getDate()).slice(-2);
  var dateString = year + " " + month + " " + day;
  return (
    <div className="header">
      <div className="header-links">
        <span>
          <Link to="/">mini memories</Link>
        </span>
      </div>
      <div className="today">today // {dateString}</div>
    </div>
  );
}

export default Header;
